import styled from 'styled-components';

import { Theme } from 'utils/color/horizonTheme';

export const ControlsContainer = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 12px;
  z-index: 5;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
  max-height: 100%;
  overflow-y: auto;
  padding: 8px;
  pointer-events: none;
`;

export const ButtonContainer = styled.div<{ $zoomControl?: boolean }>`
  display: flex;
  flex-direction: column;
  margin-top: 8px;
  margin-bottom: ${({ $zoomControl }) => ($zoomControl ? '12px' : '0px')};
  pointer-events: auto;

  &:first-child {
    margin-top: 8px;
  }
`;

export const ThumbnailControlsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

export const ThumbnailButtonContainer = styled.div`
  display: flex;
  flex-direction: row;

  &:nth-of-type(2) {
    margin-left: 8px;
  }
`;

export const LevelsContainer = styled.div`
  color: ${({ theme }) => theme.headerColor};
  width: 240px;
`;

export const LevelsButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;

  div {
    button:first-of-type {
      margin-right: 0.5rem;
    }
  }
`;

export const CustomRotationContainer = styled.div`
  color: ${({ theme }) => theme.headerColor};
  width: 260px;

  ${({ theme }) =>
    theme.themeName === Theme.Dark &&
    `
    .ant-slider-mark-text {
      color: ${theme.headerColor};
    }
  `}
`;

export const CustomRotationInputRow = styled.div`
  align-items: center;
  display: flex;
  gap: 6px;
  margin-bottom: 12px;

  .ant-input-number {
    flex: 1;
    width: 100%;
  }

  .ant-input-number-input {
    text-align: center;
  }
`;

export const CustomRotationActions = styled.div`
  display: flex;
  gap: 8px;
  justify-content: center;
  margin-top: 12px;
`;
